import { render, staticRenderFns } from "./UpgradeCuotaDialog.vue?vue&type=template&id=5c2f615a&scoped=true"
import script from "./UpgradeCuotaDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeCuotaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f615a",
  null
  
)

export default component.exports